import { render, staticRenderFns } from "./CompanyEditor.vue?vue&type=template&id=89bc0506&scoped=true"
import script from "./CompanyEditor.vue?vue&type=script&lang=js"
export * from "./CompanyEditor.vue?vue&type=script&lang=js"
import style0 from "./CompanyEditor.vue?vue&type=style&index=0&id=89bc0506&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bc0506",
  null
  
)

export default component.exports